export const NESTED_PRODUCT_CATEGORY_CODES = {
    NPC002: 'NESTED_PRODUCT_CATEGORY_ALREADY_EXISTS',
};
